/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { useFormik } from "formik";
import { login } from "../core/_requests";
import { useAuth } from "../core/Auth";
import logo from "../../../../_metronic/assets/logo/logo.png";
import "./style.scss";
import { notify } from "../../../../utils/shared";
import useTranslate from "../../../hooks/useTranslate";

const initialValues = {
  email: "",
  password: "",
  rememberMe: true,
};

export function Login() {
  const t = useTranslate();
  const loginSchema = Yup.object().shape({
    email: Yup.string().required("User name is required"),
    password: Yup.string().required(t("PASSWORD_IS_REQUIRED")),
  });
  const [loading, setLoading] = useState(false);
  const [newPassType, setNewPassType] = useState(true);
  const { saveAuth, setCurrentUser } = useAuth();

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        const { data: auth } = await login(values.email, values.password);
        auth.data.accessToken = auth?.data?.token;
        saveAuth(auth?.data);
        setCurrentUser(auth?.data);
        notify(auth.responseMessage, t("SUCCESS"));
      } catch (error: any) {
        console.log(error);
        saveAuth(undefined);
        setSubmitting(false);
        setLoading(false);
        notify(error?.response?.data?.responseMessage, "error");
      }
    },
  });

  return (
    <form
      className="form w-100 kp-login-card"
      onSubmit={formik.handleSubmit}
      noValidate
      id="kt_login_signin_form"
    >
      <div className="kp-login-logo">
        <img src={logo} alt="KeyPatrol" />
      </div>

      <div className="kp-login-heading">
        <h2>Dealer Portal Sign In</h2>
        <p>Secure access for dealership users.</p>
      </div>

      <div className="kp-login-field">
        <label htmlFor="login-email">Dealer Login</label>
        <div className="kp-login-input-wrap">
          <input
            id="login-email"
            placeholder="Enter your login"
            {...formik.getFieldProps("email")}
            className={clsx("form-control bg-transparent", {
              "is-invalid": formik.touched.email && formik.errors.email,
              "is-valid": formik.touched.email && !formik.errors.email,
            })}
            type="text"
            name="email"
            autoComplete="username"
          />
        </div>
        {formik.touched.email && formik.errors.email && (
          <div className="kp-login-error" role="alert">
            {formik.errors.email}
          </div>
        )}
      </div>

      <div className="kp-login-field">
        <label htmlFor="login-password">{t("PASSWORD")}</label>
        <div className="kp-login-input-wrap">
          <input
            id="login-password"
            placeholder="Password"
            type={newPassType ? "password" : "text"}
            autoComplete="current-password"
            {...formik.getFieldProps("password")}
            className={clsx("form-control bg-transparent", {
              "is-invalid": formik.touched.password && formik.errors.password,
              "is-valid": formik.touched.password && !formik.errors.password,
            })}
            name="password"
          />
          <i
            className={
              newPassType
                ? "bi bi-eye-slash-fill eyeIcon"
                : "bi bi-eye-fill eyeIcon"
            }
            onClick={() => setNewPassType(!newPassType)}
            role="button"
            tabIndex={0}
            aria-label={newPassType ? "Show password" : "Hide password"}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setNewPassType(!newPassType);
              }
            }}
          />
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className="kp-login-error" role="alert">
            {formik.errors.password}
          </div>
        )}
      </div>

      <div className="kp-login-remember">
        <input
          id="login-remember-me"
          type="checkbox"
          checked={formik.values.rememberMe}
          onChange={(e) => formik.setFieldValue("rememberMe", e.target.checked)}
        />
        <label htmlFor="login-remember-me">Remember me</label>
      </div>

      <button
        type="submit"
        id="kt_sign_in_submit"
        className="btn btn-primary kp-login-submit kp-hero-action-btn"
        disabled={formik.isSubmitting || !formik.isValid}
      >
        {!loading && (
          <span className="indicator-label">
            <i className="bi bi-lock-fill" />
            SIGN IN TO DEALER PORTAL
          </span>
        )}
        {loading && (
          <span className="indicator-progress" style={{ display: "block" }}>
            {t("PLEASE_WAIT")}...
            <span className="spinner-border spinner-border-sm align-middle ms-2" />
          </span>
        )}
      </button>
    </form>
  );
}
